export function newTileLinkCreator(make, model, id) {
        return `${make}-${model}-id-${id}`.replace(/ /g, '-').split('.').join('').toLowerCase();
}

